import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[form-host]'
})
export class FormHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
